module.exports = __webpack_public_path__ + "static/media/pay-with-paypal.6a707419.png";